<!--Componente que muestra la lista de evento para hacer check in
    Cuando se esta usando un dispositivo móvil se desbloquea una opción en el menú de organización al dar click
    a esa opción se muestra esta lista de eventos-->
<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <!-- LISTA DE EVENTOS PARA HACER CHECKIN -->
      <v-col
        cols="12"
        sm="11"
        v-for="(event, index) in events"
        :key="index"
        class="pb-3"
        @click="$emit('show-qr')"
        hover
      >
        <event-item :event="event"></event-item>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import eventItem from "./eventItem";
export default {
  props: {
    events: { type: Array, required: true }
  },
  components: {
    eventItem
  },
  data() {
    return {

    };
  }
};
</script>